import { fetchOrderWhichRequiresSensitiveInfoAccess, getProductOrderData } from './common';
import { PRODUCTS_LAND_REGISTRY_LOOKUP, REPORTS } from '../constants/common';
import { OrderData, Promise, services } from '@ambita/ambita-components-core';
import { Order } from '../typings/Order';
import {
  LandRegistryComponentsToMount,
  LandRegistryLookupState,
  LandRegistryPartAndState
} from '../typings/LandRegistryLookup';

enum LandRegistryState {
  active,
  historical,
  active_and_historical
}

function setLandRegistryState(productCode): LandRegistryLookupState {
  switch (productCode) {
    case ('WE25400100'):
    case ('WE25400200'):
    case ('WE25400400'):
    case ('WE25400500'):
    case ('WE25400600'):
    case ('WE25400700'):
      return <LandRegistryLookupState>LandRegistryState[LandRegistryState.active];
    case ('WE25400110'):
    case ('WE25400210'):
    case ('WE25400410'):
    case ('WE25400510'):
    case ('WE25400610'):
    case ('WE25400710'):
      return <LandRegistryLookupState>LandRegistryState[LandRegistryState.historical];
    default:
      return <LandRegistryLookupState>LandRegistryState[LandRegistryState.active_and_historical];
  }
}

const isLandRegistryProduct = function (product: string): boolean {
  return product in PRODUCTS_LAND_REGISTRY_LOOKUP;
};

export function getLandRegistryComponentsToMount(orderData: OrderData.Data): LandRegistryComponentsToMount {
  const filteredProducts = orderData.products.filter(isLandRegistryProduct);
  return filteredProducts.reduce((accumulator, productCode): LandRegistryComponentsToMount => {
    accumulator[productCode] = {
      landRegistryPart: PRODUCTS_LAND_REGISTRY_LOOKUP[productCode],
      landRegistryState: setLandRegistryState(productCode)
    };

    return accumulator;
  }, {});
}

export function fetchReportData(orderId: string, productCode: string): Promise<any> {
  const componentsToMount: LandRegistryPartAndState = {
    landRegistryPart: PRODUCTS_LAND_REGISTRY_LOOKUP[productCode],
    landRegistryState: setLandRegistryState(productCode),
    reportTitle: REPORTS[productCode]
  };

  return fetchOrderWhichRequiresSensitiveInfoAccess(orderId).then((order: Order) => {
    const orderData: OrderData.Data = getProductOrderData(productCode, order);
    return {
      orderData,
      componentsToMount
    };
  });
}

export function isLandRegistryLookupProduct(productCode: string): boolean {
  const landRegistryProductsKeys = Object.keys(PRODUCTS_LAND_REGISTRY_LOOKUP);
  return services.util.contains(landRegistryProductsKeys, productCode);
}
